import * as React from 'react';

function SvgDragMore(props) {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.381 3.23A.875.875 0 115.62 1.993.875.875 0 014.38 3.23zm0 4.375A.875.875 0 115.62 6.368.875.875 0 014.38 7.605zm0 4.375a.875.875 0 111.238-1.238.875.875 0 01-1.238 1.238zm4-8.75A.875.875 0 119.62 1.993.875.875 0 018.38 3.23zm0 4.375A.875.875 0 119.62 6.368.875.875 0 018.38 7.605zm0 4.375a.875.875 0 111.238-1.238.875.875 0 01-1.238 1.238z"
        fill="#8C8C8C"
      />
    </svg>
  );
}

export default SvgDragMore;
